import React, { PropsWithChildren, ReactNode } from 'react';

export interface WidgetProps extends PropsWithChildren {
  title?: ReactNode;
  loading?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

function Placeholder() {
  return (
    <div className='animate-pulse flex max-h-full h-72 mx-4 p-6 rounded-3xl shadow-sm bg-gray-300' />
  );
}

export default function Widget({
  children,
  title,
  loading = true,
  actions,
  className = '',
}: WidgetProps) {
  if (loading) return <Placeholder />;

  return (
    <div
      className={`grow p-3 lg:p-6 flex flex-col bg-white dark:bg-[#242424] rounded-3xl shadow-sm hover:drop-shadow-md transition-all duration-300 ease-in-out ${className}`}
    >
      <div className='flex justify-between items-center mb-4'>
        {title && (
          <div className='text-base leading-6 md:text-xl md:leading-7 font-bold dark:text-white'>
            {title}
          </div>
        )}
        <div className=''>{actions}</div>
      </div>
      <div className='grow'>{children}</div>
    </div>
  );
}

Widget.Placeholder = Placeholder;
